import type { GetStaticProps, NextPage } from 'next'

import { BlogPage, BlogPageProps } from 'src/App/BlogPage/BlogPage'
import { strapiGetArticles } from 'src/strapi/api/getArticles'
import { strapiGetTags } from 'src/strapi/api/getTags'
import { ArticleClientType } from 'src/strapi/types/articleTypes'
import { TagClientType } from 'src/strapi/types/tagTypes'

const Blog: NextPage<BlogPageProps> = (props) => <BlogPage {...props} />

export const getStaticProps: GetStaticProps<BlogPageProps> = async () => {
  let articles: Array<ArticleClientType> = []
  let tags: Array<TagClientType> = []

  try {
    const strapiArticles = (await strapiGetArticles({
      withImage: true,
      withTags: true,
    })) as Array<ArticleClientType>
    const strapiTags = await strapiGetTags()

    if (strapiArticles.length && strapiTags.length) {
      articles = strapiArticles
      tags = strapiTags
    } else {
      throw new Error()
    }
  } catch (e) {
    throw new Error('Failed to load data for page /blog', e as unknown as Error)
  }

  return {
    revalidate: false,
    props: {
      articles,
      tags,
    },
  }
}

export default Blog
